<template>
<ScrollPanel style="width: 100%; height: 80vh" class="left_sidebar_scroll">
<template v-if="!tickets.length">
<h4 class="text-primary font-medium">{{$store.state.languages.lang_phrases.henuz_hic_destek_talebiniz_yok}}</h4>
</template>
<template v-else>



<div class="grid mb-3" v-for="ticket in tickets" :key="ticket.id">

<div class="col-6 md:col-8" @click="displayTicket(ticket.id)">


<TicketListLine :message="ticket.lastconversation.description" ></TicketListLine>

</div>
<div class="col-6  md:col-4 pr-5">
<div class="grid ">
<div class="col-6">
<div class="flex align-items-center justify-content-end ">
<p class="p-link font-bold text-xs mr-3 pt-2 mt-1">{{ $filters.momentFormat( ticket.lastconversation.created_at," Do-MM-YYYY HH:mm")}}</p>
</div>
</div>

<div class="col-6">
<template v-if="ticket.status">
 <Tag 
class="mr-2 mt-2 custom-chip"   
:value="$store.state.languages.lang_phrases.cozumlendi" 
style="background-color:#4dc247"
/>
</template>
<template v-else>

  <template v-if="ticket.lastconversation.submitted_by==$store.state.auth.user.id">
     <Tag 
    class="mr-2 mt-2 custom-chip"   
    :value="$store.state.languages.lang_phrases.degerlendirmede" 
    style="background-color:#ff6600"
    />
  </template>

  <template v-else>
    <template v-if="!ticket.lastconversation.is_read">
      <Tag 
    class="mr-2 mt-2 custom-chip"   
    :value="$store.state.languages.lang_phrases.cevaplandi" 
    style="background-color:#3b82f6"
     v-badge.danger
    />
    </template>
    <template v-else>
      <Tag 
    class="mr-2 mt-2 custom-chip"   
    :value="$store.state.languages.lang_phrases.cevaplandi" 
    style="background-color:#3b82f6"
    />
    </template>
     
  </template>
  
</template>
</div>
</div>

</div>




</div>








</template>
</ScrollPanel>
</template>

<script>
import TicketListLine from "./TicketListLine"
export default {

  name: 'TicketsList',
  props:["tickets"],
  components:{TicketListLine},
  data () {
    return {

    }
  },
  methods:{
    displayTicket(id)
    {
      this.$emit("displayTicket",id)
    }
  }
}
</script>

<style lang="css" scoped>
</style>